//@vendor
const moment = require('moment');

//@utilities
const { formatText } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');

// @constants
const { DATE_FORMAT_MONTH_YEAR, DATE_FORMAT_API } = require('constants/index');

function getLast6Months(){
    const last6MonthsArray = new Array(7)
        .join().split(',')
        .map(function(item, index){
        let _index = index;
        
        const last6MonthsOptionList = DateHelper.buildFormattedDate(moment().subtract(_index, 'months'), DATE_FORMAT_MONTH_YEAR)
        const last6MonthsOptionsValue = DateHelper.buildFormattedDate(moment().subtract(_index, 'months'), DATE_FORMAT_API)
        let valueToReturn = {
            value: last6MonthsOptionsValue,
            label: last6MonthsOptionList
        }

        if(index === 0) {
            valueToReturn = {
                value: last6MonthsOptionsValue,
                label: `${formatText('openYoungBudgetFilter-labelCurrentMonth')} (${last6MonthsOptionList})`
            };
        }
        return valueToReturn;

    });

    return last6MonthsArray;
}


module.exports = getLast6Months;
